import { createFileRoute } from '@tanstack/react-router';

import { creditNoteNewScreen, creditNoteNewSearch, loadCreditNoteMessages, loadCreditNoteNewScreen } from '@/modules/credit-note/route';
import { lazyScreen } from '@/shared/screen';

// Mesmo caminho do legado (`/ccb/operacoes/nova`): o segmento fixo vence o `$creditNoteId`.
export const Route = createFileRoute('/_app/ccb/operacoes/nova')({
  validateSearch: creditNoteNewSearch,
  staticData: { screen: creditNoteNewScreen },
  loader: () => loadCreditNoteMessages(),
  component: lazyScreen(loadCreditNoteNewScreen, 'CreditNoteNewScreen'),
});
